export const PROD_CONFIG = {
    cdn: {
        contentCDN: 'https://cdn.public.zooplus.net',
    },
};
